import * as React from 'react';
import type { SVGProps } from 'react';

const SvgMediaKit = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={41} height={31} fill="none" {...props}>
    <path
      fill="#000000"
      d="M20.235 9.324a3.465 3.465 0 0 0-.8 6.836v5.279a3.466 3.466 0 1 0 1.6 0V16.16a3.464 3.464 0 0 0-.8-6.836Zm1.867 15.484a1.867 1.867 0 1 1-3.734 0 1.867 1.867 0 0 1 3.734 0Zm-1.867-10.15a1.867 1.867 0 1 1 0-3.735 1.867 1.867 0 0 1 0 3.734Z"
    />
    <path
      fill="#000000"
      d="M38.05.15H2.418A2.187 2.187 0 0 0 .234 2.335v26.244a2.186 2.186 0 0 0 2.184 2.185H38.05a2.187 2.187 0 0 0 2.184-2.185V2.335A2.187 2.187 0 0 0 38.05.15Zm.584 6.353c-.004 6.256-6.47 10.765-16 11.413v1.603c7.537-.49 13.338-3.3 16-7.51v16.57a.586.586 0 0 1-.584.585H2.418a.585.585 0 0 1-.584-.585V12.01c2.663 4.21 8.463 7.02 16 7.51v-1.603c-9.53-.648-15.995-5.156-16-11.412v-4.17a.585.585 0 0 1 .584-.584H38.05a.585.585 0 0 1 .584.585v4.168Z"
    />
  </svg>
);
export default SvgMediaKit;
